import React from 'react';
import { Controller, FormProvider } from 'react-hook-form';
import InputFieldV2 from '../../../lib/input/InputFieldV2';
import DatePickerV2 from '../../../global/ui/DatePickerV2';
import { apiConstants } from '../../../utils/apiConstants';
import { EMAIL_VALIDATION, MOBILE_VALIDATION, REQUIRED_VALIDATION } from '../../../lib/input/validation-rules';
import PhoneInputV2 from '../../../lib/input/Phoneinputv2';
import GoogleSearchPlaceInputV2 from '../../../components/customGooglePlaceSearch/Googlesearchplaceinputv2';
import DropDownV2 from '../../../global/ui/DropDownV2';
import { scoutingTags } from '../../../data/data';
import { setDropdownSelectedValue } from '../../../utils';
interface Props {
    createLocData?: any;
}

const StepLocationDetails: React.FC<Props> = ({ createLocData }) => {

    return (
        <FormProvider {...createLocData}>
            <div className="cl-step">
                <h3 className="cl-step__heading">Location Details</h3>
                <div className="cl-step__fields">
                    <InputFieldV2
                        name={apiConstants.name}
                        label="Location name"
                        type="text"
                        placeholder="Enter location name"
                        rules={REQUIRED_VALIDATION('Location name')}
                        maxLength={150}
                    />
                    <Controller
                        name={apiConstants.address}
                        control={createLocData.control}
                        rules={{
                            required: false
                        }}
                        render={({ field, fieldState }) => (
                            <GoogleSearchPlaceInputV2
                                className="update"
                                selectedAddress={field.value || ""}
                                onSelect={(data) => {
                                    createLocData.setValue(apiConstants.coordinates, {
                                        type: "Point",
                                        coordinates: data?.coordinates,
                                    }, { shouldValidate: true, })
                                    field.onChange(data?.address);
                                }}
                                errorMessage={fieldState?.error?.message || ''}
                            />
                        )}
                    />
                    <InputFieldV2
                        name={apiConstants.contact_person}
                        label="Contact"
                        type="text"
                        placeholder="Enter contact detail"
                        rules={{
                            required: false
                        }}
                        maxLength={150}
                    />
                    <InputFieldV2
                        name={apiConstants.contact_email}
                        label="Email"
                        type="email"
                        placeholder="Enter email address"
                        rules={{
                            required: false
                        }}
                        maxLength={100}
                    />
                    <PhoneInputV2
                        name={apiConstants.contact_phone_number}
                        countryName={apiConstants.dial_code}
                        label="Phone number"
                        placeholder='Enter contact number'
                        rules={{
                            required: false
                        }}
                    />
                    <InputFieldV2
                        name={apiConstants.shoot_rate}
                        label="Shoot Rate"
                        type="number"
                        placeholder="Enter shoot rate"
                        // rules={{
                        //     required: "Shoot rate is required",
                        //     max: {
                        //         value: 999999,
                        //         message: "Maximum value is 999999",
                        //     },
                        // }}
                        rules={{
                            required: false
                        }}
                        leftIcon='/assets/images/gbpmoney.png'
                    />
                    <Controller
                        name={apiConstants.date_scouted}
                        control={createLocData.control}
                        // rules={{
                        //     required: "Date scouted is required",
                        // }}
                        rules={{
                            required: false
                        }}
                        render={({ field, fieldState }) => (
                            <DatePickerV2
                                date={field.value}
                                onDateChange={d => createLocData.setValue(apiConstants.date_scouted, d, { shouldValidate: true, })}
                                label="Date Scouted"
                                placeholder="Select date"
                                openDirection="up"
                                allowPastDate
                                errorMessage={fieldState?.error?.message || ''}
                                rightIcon='/assets/images/calendar1.svg'
                            />
                        )}
                    />

                    <div className="personal-info__field">
                        <label className="personal-info__label">Scouting Tags</label>
                        <DropDownV2
                            isClearable={false}
                            data={scoutingTags}
                            onSelect={(el) => {
                                createLocData.setValue(apiConstants.scouting_tags, el?.value, { shouldValidate: true, })
                            }}
                            selectedItems={setDropdownSelectedValue(scoutingTags, createLocData.getValues(apiConstants.scouting_tags))}
                            placeholder='Please select scouting tags'
                        />
                    </div>
                </div>
            </div>
        </FormProvider>
    );
};

export default StepLocationDetails;